import React from "react";

import { TextField } from "../../../../components/forms/fields";

const AlternativeName = () => (
    <TextField
        name="alternativeName"
        type="text"
        label="Alternative Name"
        isRequired
    />
);

export default AlternativeName;
